import React from 'react';
import NOCNLogo from '../assets/images/logoNOCN.png';

const Header = () => (
  <header>
    <div className="container">
      <a href="https://cpcs.nocn.org.uk/" target="_blank" rel="noopener noreferrer">
        <img src={NOCNLogo} alt="corporative NOCN logo" width="120" height="144" />
      </a>
      <h1>Renewal Test Tool – CPD</h1>
    </div>
  </header>
);
export default Header;
